/* eslint-disable valid-jsdoc */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useContext } from 'react';
import { MLProductCodeUtil } from 'ml-portals-util-js';
import { MLBundleService } from 'ml-services-common-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import { MLWizardDataSnapshotContext } from 'ml-portals-util-react';
import RenderStep from './renderStep';


function renderSteps(
    translator,
    steps,
    currentStepId,
    currentStepIndex,
    parentStepId,
    jumpTo,
    wizardContext,
    customMessageModal,
    originalSteps,
    model,
    wizardDataWithSnapshotFlag
) {

    const cannotSelectStep = (step) => {
        const BOOKROLL_WITH_RATE_CAPPING = 'with_Rate_Capping';
        const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';

        const checkIfTransitionAllowedForPostQuote = () => {
            if (model.isBundle_ML) {
                const isPostQuoteBundle = MLBundleService.isJobForPostQuote(model.quoteID);
                const quoteDetailsStepIndex = _.findIndex(steps, ({mlStepName}) => mlStepName === 'quoteDetails');
                return !(isPostQuoteBundle && (currentStepIndex < quoteDetailsStepIndex));
            }
            return true;
        };

        const checkIfTransitionAllowedForBookRoll = () => {
            return step.mlStepName === 'quoteDetails' || (model.bookrollInd_ML !== BOOKROLL_WITH_RATE_CAPPING && model.bookrollInd_ML !== BOOKROLL_WITHOUT_RATE_CAPPING);
        };

        const checkIfTransitionAllowedWhenNotAK7DayPolicy = () => {
            const productCode = _.get(model, 'baseData.productCode', '');
            const isPersonalAuto = MLProductCodeUtil.isPersonalAuto(productCode);
            return !(isPersonalAuto && model.baseData && model.baseData.policyAddress.state === 'AK' && model.baseData.termType === '7Days');
        };

        const checkForValidationMessages = () => {
            const offeredQuotes = _.get(model, 'quoteData.offeredQuotes', {});

            return !Object.values(offeredQuotes).some(
                quote => quote?.validationErrors_ML?.length > 0
            );
        };
        const transitionAllowed = checkForValidationMessages() && checkIfTransitionAllowedForPostQuote(step, model) && checkIfTransitionAllowedForBookRoll() && checkIfTransitionAllowedWhenNotAK7DayPolicy(model);
        return !transitionAllowed;
    };

    return steps.map((step) => {
        return <RenderStep 
            step={step}
            steps={steps} 
            translator={translator} 
            currentStepId={currentStepId} 
            parentStepId={parentStepId}
            originalSteps={originalSteps}
            jumpTo={jumpTo}
            wizardContext={wizardContext}
            cannotSelectStep={cannotSelectStep(step)}
            wizardDataWithSnapshotFlag={wizardDataWithSnapshotFlag}/>
    });
}


function WizardStepProgressComponent(props) {
    const wizardContext = useContext(WizardContext);
    const translator = useTranslator();
    const { wizardDataWithSnapshotFlag } = useContext(MLWizardDataSnapshotContext);
    const {
        steps, currentStep, jumpTo, currentStepIndex, wizardData : submissionVM, wizardSnapshot, updateWizardData
    } = wizardContext;
    let parentStepId = _.get(currentStep, 'stepProps.sidebarConfig.parentStepId');
    const rentersParentStepId = _.get(currentStep, 'stepProps.sidebarConfig.rentersParentStepId');
    const { customMessageModal } = props;   
    const isPersonalAuto = submissionVM.baseData.productCode.value === 'PersonalAuto'  || false;

    const coveragePartType = _.get(submissionVM, "lobData.homeowners.coverables.coveragePartType_ML.value.code");
    const isRenters = MLProductCodeUtil.isHomeOwners(submissionVM.baseData.productCode.value) && MLProductCodeUtil.isHomeOwnersPartialTypeRental(coveragePartType);
    
    if (isPersonalAuto){
        const vehiclesListPath = 'lobData.personalAuto.coverables.vehicles.value';
        const vehiclesList = _.get(submissionVM, vehiclesListPath);
        if (vehiclesList !== undefined && vehiclesList.length !==0 ) {
            steps.filter((item) => {
                return item.path === '/vehicles';
            }).forEach((item) => {
                item.stepProps.showInNavigation = true;
            });
        }
    }
    if(isRenters && rentersParentStepId){
        _.set(currentStep, 'stepProps.sidebarConfig.parentStepId', rentersParentStepId)
        parentStepId = _.get(currentStep, 'stepProps.sidebarConfig.parentStepId');
    }
    
    
    const quoteStepIndex = steps.findIndex((item) =>{        
        return item.path === '/quote';
    }
    );

    if (wizardDataWithSnapshotFlag.current) {
        _.set(submissionVM, 'value', _.cloneDeep(wizardSnapshot.value));
        updateWizardData(submissionVM);
        wizardDataWithSnapshotFlag.current = false;
    }

    let stepsToShow;
    if(currentStepIndex > quoteStepIndex){
        stepsToShow =  steps.slice(quoteStepIndex, steps.length);
    }else{
        stepsToShow = steps.filter((item) => {
            return _.get(item, 'stepProps.showInNavigation');
        });
    }  

    return (

        <ul className="container qb-progress-header__wrapper qb-progress-header__items">
            {renderSteps(
                translator,
                stepsToShow,
                currentStep.id,
                currentStepIndex,
                parentStepId,
                jumpTo,
                wizardContext,
                customMessageModal,
                steps,
                submissionVM.value,
                wizardDataWithSnapshotFlag
            )}
        </ul>
    );
}

WizardStepProgressComponent.propTypes = {
    customMessageModal: PropTypes.shape({})
};


WizardStepProgressComponent.defaultProps = {
    customMessageModal: {}
};


export default WizardStepProgressComponent;
